import {Injectable} from '@angular/core';
import {PwaPlatform} from './pwa-platform.service';

@Injectable()
export class PwaModeService {
  private enabled: boolean;

  constructor(platform: PwaPlatform) {
    this.enabled = platform.isStandalone || platform.hasModeQuery || platform.readMode();
    if (this.enabled) { platform.rememberMode(); }
  }

  get isEnabled(): boolean { return this.enabled; }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/pwa-mode.service.ts